export const getIsSignalsListFetching = (state) =>
  state.signals.list.isFetching;

export const getIsSignalsListErrorMessage = (state) =>
  state.signals.list.errorMessage;

export const getIsSignalsListResponse = (state) =>
  state.signals.list.data || {};

export const getSignalsList = (state) =>
  state.signals.list.data.data ? state.signals.list.data.data : [];

export const getSignalsPaging = (state) =>
  state.signals.list.data.paging ? state.signals.list.data.paging : {};

export const getSignalsLastPage = (state) =>
  state.signals.list.page ? state.signals.list.page : 1;

export const getSignalsListCached = (state) =>
  state.signals.list.dataCached || [];

export const getSignalsListRenameDataModal = (state) =>
  state.signals.list.renameDataModal;

export const getSignalsListDeleteDataModal = (state) =>
  state.signals.list.deleteDataModal;

export const getSignalsListExpiryDataModal = (state) =>
  state.signals.list.expiryDataModal;

export const getSignalsListModalErrors = (state) =>
  state.signals.list.modalErrors;

export const getIsSignalsListOk = (state) =>
  state.signals.list.data &&
  state.signals.list.data.status &&
  state.signals.list.data.status === 'success'
    ? true
    : false;

export const getSignalsListUpdateTime = (state) =>
  state.signals.list.updateTime;

export const getSignalsListCacheUpdateTime = (state) =>
  state.signals.list.cacheUpdateTime;

export const getSignalsListFiltersUpdateTime = (state) =>
  state.signals.list.filtersUpdateTime;

export const getSignalsListTableSorting = (state) => state.signals.list.sorting;

export const getSignalsListTableColumnToggleData = (state) =>
  state.signals.list?.tableSettings?.columnToggle?.data || {};

export const getSignalsListTableColumnToggleUpdateTime = (state) =>
  state.signals.list?.tableSettings?.columnToggle?.updateTime;

export const getSignalsListMultiSelectSelected = (state) =>
  state.signals.list.multiSelectSelected;

export const getSignalsListShiftPressed = (state) =>
  state.signals.list.shiftPressed;
